export default __webpack_public_path__ + "static/media/central_andes_2_13.817e30af.JPG";